export default __webpack_public_path__ + "static/media/blog_inner_17.8d20e0ed.jpg";